var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4, _circle5, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCampingThumbnail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#A3BA8B",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M21.3749 64.2665C33.1043 63.0447 37.4769 67.7706 38.1971 70.2863C43.1553 80.858 43.7197 92.8508 42.453 99.3404C32.4608 99.7595 36.493 100.665 28.501 101C26.5027 101.084 25.4076 92.0743 15.3656 92.5261C8.81574 92.8208 3.83545 89.664 2.29117 84.6323C0.746876 79.6006 6.71321 65.7938 21.3749 64.2665Z",
    fill: "#875202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M55.501 78C44.701 77.2 31.3343 97.5 28.501 101H89.001C85.801 95.8 71.1676 76.3333 67.501 76.5C70.301 68.5 78.1676 63.1667 82.001 61L44.001 67C52.801 69.8 56.1676 74.8333 55.501 78Z",
    fill: "#533200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M38.001 26.0001C41.601 26.4001 44.1676 28.8334 45.001 30.0001L41.501 36.0001C39.001 36.6667 34.001 37.1001 34.001 33.5001C34.001 29.9001 32.6676 27.6667 32.001 27.0001C32.501 26.5001 34.401 25.6001 38.001 26.0001Z",
    fill: "#533200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M79.001 17C75.001 17.8 72.6676 22 72.001 24L75.501 27.5C76.6676 26.8333 79.201 24.9 80.001 22.5C80.801 20.1 79.6676 17.8333 79.001 17Z",
    fill: "#533200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M44.3303 27.7714C37.6668 32.2485 36.001 45.9175 36.001 52.1923C45.9962 58.2976 70.7066 53.0403 82.8536 49.6485C82.8536 46.935 84.4153 42.5257 83.8947 36.4205C83.542 32.284 77.3007 25.9059 74.5242 23.1924C68.7978 20.6486 52.6597 22.1749 44.3303 27.7714Z",
    fill: "#533200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M46.001 30.4999C40.401 34.8999 38.3343 47.9999 38.001 53.9999C50.801 55.9999 59.001 51.4999 61.501 48.9999C57.501 31.7999 49.501 29.4999 46.001 30.4999Z",
    fill: "#875202"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M73.001 35.5C73.001 39.1 77.3343 44.3333 79.501 46.5C81.501 45.5 86.501 44.5 84.501 37.5C82.901 31.9 77.8343 26.5 75.501 24.5C73.501 25.5 73.001 31 73.001 35.5Z",
    fill: "#875202"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M48.5007 51C50.5007 51 57.0007 50 60.0007 49.5C63.1674 49.1667 70.2007 48.2 73.0007 47C76.5007 45.5 85.0007 43.5 87.0007 45C89.0007 46.5 90.0007 48 90.0007 51.5C90.0007 55 86.0007 59 82.5007 61C79.0007 63 75.5007 63 74.0007 63C72.8007 63 71.1674 64.3333 70.5007 65C62.5007 70 61.0007 69.5 49.5007 68.5C38.0007 67.5 34.0007 61.5 33.0007 58C32.0007 54.5 33.5007 51.5 36.0007 50.5C38.5007 49.5 46.0007 51 48.5007 51Z",
    fill: "#533200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7545 65.8637C76.0794 63.2455 76.2179 57.8637 75.8716 55.5C74.6247 56.8091 68.7717 57.5 66.001 57.6818C66.001 58.7728 68.5985 69.1365 72.7545 65.8637Z",
    fill: "#F9F7F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M58.5008 50C58.9008 48 62.1674 47 63.5007 47C67.3341 46.5 74.9043 44.8999 76.5043 44.4999C78.5043 43.9999 77.5189 58.8314 72.5045 59.5C65.0046 60.5 58.0008 52.5 58.5008 50Z",
    fill: "#875202"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.501 51.0503C73.301 50.6503 75.1676 46.8836 76.001 45.0503C70.401 43.4503 65.001 45.717 63.001 47.0503C65.6676 48.3836 71.301 51.0503 72.501 51.0503Z",
    fill: "#2E1B00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5621 42.6188C55.3621 39.4188 52.8395 39.2998 50.0621 39.6188C46.1823 40.0645 43.5621 43.1188 44.0621 47.6188C44.4621 51.2188 49.3027 51.9485 52.5621 50.6188C55.7962 49.2994 57.7621 45.8188 56.5621 42.6188Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.731 37.8333C84.7952 35.1666 81.2056 34.5 79.5013 35C78.0012 39.5 80.8566 43.7592 83.0013 44.5C85.0013 44.5 86.6669 40.5 85.731 37.8333Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.501,
    cy: 46,
    r: 1.5,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.501,
    cy: 39,
    r: 2.5,
    fill: "#2E1B00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.001,
    cy: 45.5,
    r: 4,
    fill: "#2E1B00"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.001,
    cy: 44.5,
    r: 1,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.501,
    cy: 38,
    r: 0.5,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-dark",
    d: "M72.001 62V67",
    stroke: "#533200",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fur-light",
    d: "M53 100.721C53.0336 93.2632 54.3798 85.7378 59.6891 84.2208C66.0094 82.415 73.2356 92.0224 77.7689 100.721H53Z",
    fill: "#875202"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCampingThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CampingThumbnail.ed6feae551948bde5db9750685eb52ae.svg";